<template>
  <div :class="{'modal-open':isSomeModalOpen,'filters-open':showFilters}">
    <div class="fixed-part">
      <page-header @mounted="useFixedPart" :clientView="true"></page-header>
    </div>

    <b-container fluid class="outer" >
      <b-tabs class="campaign-tabs" @activate-tab="activateTab">
        <b-tab title="In production" active>
          <campaigns-table />
        </b-tab>
        <b-tab title="Past campaigns">
          <past-campaigns-table />
        </b-tab>
        <b-tab title="Invoices">
          <invoices-table />
        </b-tab>
      </b-tabs>
    </b-container>

    <b-container fluid class="outer"><server-processing :serverIsBusy="dataLoading"/></b-container>

  </div>

</template>

<script>
import fixedHeader from '../_mixins/fixed-header.js';

export default {
  components: {
    'page-header': () => import('@/components/Header.vue'),
    'value-item': () => import('@/components/ValueItem.vue'),
    'campaigns-table': () => import('@/components/CampaignsTable.vue'),
    'past-campaigns-table': () => import('@/components/PastCampaignsTable.vue'),
    'invoices-table': () => import('@/components/InvoicesTable.vue'),
  },
  mixins: [fixedHeader],
  props: {
    client_id: {
      type: Number
    }
  },
  data: () => ({
    selectedPage: 1,
    totalPages: 1,
    rowsPerPage: 20,
    URLsListLoading: false,
    URLsList: [],
    showFilters: false,
    filters: {},
    fixedPart: null,
    fixedPartHeight: 0,
  }),
  methods: {
    activateTab(newTabIndex) {
      if (newTabIndex===2) {
        this.$store.dispatch('campaigns/getInvoices');
      }
    },
    addItem() {
      this.$refs.newCampaign.show();
    },
    campaignsInit() {
      this.$store.dispatch('campaigns/getAll');
    },
  },
  computed: {
    isSomeModalOpen() {
      return false;
    },
    dataLoading() {
      return this.$store.state.reports.serverProcessing || false;
    },
    filteredLinksActive() {
      return this.getFilteredReports();
    },
    reports() {
      let items = this.filteredLinksActive;
      if (items && items.length) {
        const begin = (this.selectedPage - 1) * this.rowsPerPage;
        items = items.slice(begin, begin + this.rowsPerPage);
      }
      return items;
    },
    user() {
      return this.$store.state.authentication.user;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';
@import '../assets/_scss/components/action-panel';
@import '../assets/_scss/components/campaign-tabs';


.action-holder {
  padding: 15px 0;
}
</style>
